import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  height: 100%;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: ",
    ";\n  height: 100%;\n  width: 100%;\n"])), function (props) {
    return props.layout === 'horizontal' ? 'row' : 'column';
});
var templateObject_1;
